import { Routes, Route, Navigate } from "react-router-dom"
import { Toaster, ToastBar, toast } from "react-hot-toast"

import { ROUTES } from "./constants"
import { useScrollToTop } from "./hooks"

// Layout
import { Main } from "./pages/Main/Main"
import { ModalBase } from "./components/modals/ModalBase/ModalBase"

// Public pages
import { Home } from "./pages/Home/Home"
import { NotFound } from "./pages/NotFound/NotFound"

// Protected pages
import { Profile } from "./pages/Profile/Profile"
import { ProtectedRoute } from "./components/features/ProtectedRoute/ProtectedRoute"

// Auth pages
import { Login } from "./pages/auth/Login/Login"
import { Register } from "./pages/auth/Register/Register"
import { VerifyEmail } from "./pages/auth/VerifyEmail/VerifyEmail"
import { ForgotPassword } from "./pages/auth/ForgotPassword/ForgotPassword"
import { ChangePassword } from "./pages/auth/ChangePassword/ChangePassword"

// MMMS Pages
import { WeeklyReport } from "./pages/WeeklyReport/WeeklyReport"
import { WeeklyReportView } from "./pages/WeeklyReport/WeeklyReportView"
import { TechnicalAssessment } from "./pages/TechnicalAssessment/TechnicalAssessment"
import { TechnicalAssessmentView } from "./pages/TechnicalAssessment/TechnicalAssessmentView"
import { PartsRequisition } from "./pages/PartsRequisition/PartsRequisition"
import { PartsRequisitionView } from "./pages/PartsRequisition/PartsRequisitionView"
import { ReportsLibrary } from "./pages/ReportsLibrary/ReportsLibrary"

import './App.css'
import './styles/print.css'

function App() {
    // The new AuthStore no longer needs initialization as it
    // checks token validity on creation
    useScrollToTop();

    return (
        <div className="App">
            <ModalBase />
            <Toaster
                position="top-center"
                toastOptions={{
                    duration: 5000,
                    success: { className: "toast-success" },
                    error: { className: "toast-error" },
                    style: {
                        zIndex: 20
                    }
                }}
                children={(toasts) => (
                    <ToastBar toast={toasts}>
                        {({ icon, message }) => (
                            <div
                                onClick={() => toast.dismiss()}
                                style={{ cursor: "pointer", display: "flex" }}
                            >
                                {icon}
                                {message}
                            </div>
                        )}
                    </ToastBar>
                )}
            />
            <Routes>
                {/* Public auth endpoints */}
                <Route path={ROUTES.login} element={<Login />} />
                <Route path={ROUTES.register} element={<Register />} />
                <Route path={ROUTES.verifyEmail} element={<VerifyEmail />} />
                <Route path={ROUTES.forgotPassword} element={<ForgotPassword />} />

                {/* Protected auth endpoints */}
                <Route element={<ProtectedRoute redirectToLogin />}>
                    <Route path={ROUTES.changePassword} element={<ChangePassword />} />
                </Route>

                <Route path={ROUTES.main} element={<Main />}>
                    {/* Public routes */}
                    <Route path={ROUTES.home} element={<Home />} />

                    {/* MMMS Routes (Public) */}
                    <Route path={ROUTES.weeklyReport} element={<WeeklyReport />} />
                    <Route path={ROUTES.weeklyReportEdit} element={<WeeklyReport />} />
                    <Route path={ROUTES.weeklyReportView} element={<WeeklyReportView />} />
                    <Route path={ROUTES.technicalAssessment} element={<TechnicalAssessment />} />
                    <Route path={ROUTES.technicalAssessmentEdit} element={<TechnicalAssessment />} />
                    <Route path={ROUTES.technicalAssessmentView} element={<TechnicalAssessmentView />} />
                    <Route path={ROUTES.partsRequisition} element={<PartsRequisition />} />
                    <Route path={ROUTES.partsRequisitionEdit} element={<PartsRequisition />} />
                    <Route path={ROUTES.partsRequisitionView} element={<PartsRequisitionView />} />
                    <Route path={ROUTES.reportsLibrary} element={<ReportsLibrary />} />

                    {/* Protected routes - require authentication */}
                    <Route element={<ProtectedRoute />}>
                        <Route path={ROUTES.profile} element={<Profile />} />
                        {/* Add more protected routes here */}
                    </Route>
                </Route>
                <Route path={ROUTES.notFound} element={<NotFound />} />
                <Route path="*" element={<Navigate to={ROUTES.notFound} replace />} />
            </Routes>
        </div>
    )
}

export { App }

